// extracted by mini-css-extract-plugin
module.exports = {"container":"packages-primitives-ErrorBind-ComponentError-style__container--3g_K6","innerContainer":"packages-primitives-ErrorBind-ComponentError-style__innerContainer--1gbGt"};